import React, { useEffect, useState } from 'react';
import PartnerFund from '../PartnerFund/PartnerFund';
import PartnerInfo from '../PartnerInfo/PartnerInfo';
import './partner.css'
import client from '../../../utils/prismicHelpers';
import * as queries from "../../../utils/prismicQueries";

const PartnerSection = () => {

  const [parnterInfo, setParnterInfo] = useState(null);
  const [partnersContent, setPartnersContent] = useState(null);
  useEffect(() => {
    client
      .query({
        query: queries.partnerInfo,
      })
      .then((response) => {
        const partnersContent = response.data.allPartners.edges[0].node;
        setPartnersContent(partnersContent);
        setParnterInfo(partnersContent.partner_info);

      })
      .catch((error) => {
        console.error(error);
      });
  });
  return (

    <section className="partner-container pattern" >
      <div className="container "    >
        <PartnerInfo></PartnerInfo>
        <PartnerFund></PartnerFund>
      </div>
    </section>
  );
};

export default PartnerSection;